module.exports = __webpack_public_path__ + "static/media/everybrand_logo_filled.4bdff5cc.svg";